import * as types from '@/store/mutation-types';
import router from '@/router';

const getters = {
  credentials: state => state.credentials,
  token: state => state.token,
  isLoggedIn: state => state.isLoggedIn,
  user: state => state.user,
};

const actions = {
  async userLogin({ commit }, payload) {
    try {
      commit(types.SAVE_TOKEN, ''); // reset any auth token to ensure that login works
      await this._vm.$directus.auth.login(payload);
      var user = await this._vm.$directus.users.me.read({
        fields: ['*', 'company.*', 'user.*'],
      });
      //console.log('User logged in');
      commit(types.SET_LOGGED_IN, true);
      commit(types.SAVE_CREDENTIALS, payload);
      commit(types.SAVE_USER, user);
      router.push({
        name: 'home',
      });
      return true;
    } catch (error) {
      if (error.message.indexOf('Invalid user credentials.') >= 0) return false;
      else
        throw new Error(
          'Fehler bei der Anmeldung. Probieren Sie es später erneut.',
        );
    }
  },
  async autoLogin({ commit, dispatch }) {
    try {
      const result = await this._vm.$directus.auth.refresh();
      if (!result.access_token) throw new Error();
      // else console.log('Token refreshed.');
    } catch (error) {
      //console.error('Token could not be retrieved');
      await dispatch('setLogoutState');
      return false;
    }
    try {
      var user = await this._vm.$directus.users.me.read({
        fields: ['*', 'company.*', 'user.*', 'user.company.*'],
      });
      commit(types.SET_LOGGED_IN, true);
      commit(types.SAVE_USER, user);
      return true;
    } catch (error) {
      dispatch('showErrorMessage', error.message);
      return false;
    }
  },
  async userLogout({ dispatch }) {
    try {
      await this._vm.$directus.auth.logout();
    } catch (error) {
      // ignored
    }
    await dispatch('setLogoutState');
  },
  async setLogoutState({ commit }) {
    commit(types.SAVE_TOKEN, '');
    commit(types.SET_LOGGED_IN, false);
    if (router.history.current.name !== 'login')
      router.push({
        name: 'login',
      });
  },
  async requestPasswordReset(_, payload) {
    try {
      await this._vm.$directus.transport.post('/password/request', payload);
      return true;
    } catch (error) {
      return false;
    }
  },
  async resetPassword(_, payload) {
    try {
      await this._vm.$directus.auth.password.reset(
        payload.token,
        payload.password,
      );
      return true;
    } catch (error) {
      return false;
    }
  },
  async getUser({ commit }) {
    try {
      var user = await this._vm.$directus.users.me.read({
        fields: ['*', 'company.*', 'user.*'],
      });
      commit(types.SAVE_USER, user);
    } catch (error) {
      commit(types.SHOW_ERROR, error.message);
    }
  },
};

const mutations = {
  [types.SAVE_CREDENTIALS](state, credentials) {
    state.credentials = credentials;
    //this._vm.$cookies.config('7d', '', '', true);
    //this._vm.$cookies.set('user', credentials);
  },
  [types.SAVE_TOKEN](state, token) {
    state.token = token;
    window.localStorage.setItem('auth_token', token);
  },
  [types.SET_LOGGED_IN](state, loginState) {
    state.isLoggedIn = loginState;
  },
  [types.SAVE_USER](state, user) {
    if (user.user) user = user.user;
    state.user = user;
  },
};

const state = {
  credentials: undefined,
  isLoggedIn: JSON.parse(!!localStorage.getItem('auth_token')) || false,
  user: undefined,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
